
import { DscFuncInvPEDe } from '../general/variables';
import { Cargo } from './Cargo';
import { Persona } from './Persona';
import { TipoDocumento } from './TipoDocumento';

export class Denunciado {
  ndenunciadoId: number;
  persona: Persona;
  tipoDocumento: TipoDocumento;
  cdenunciadoNrodoc: string;
  cdenunciadoApepaterno: string;
  cdenunciadoApematerno = '';
  cdenunciadoNombres: string;
  cdenunciadoFlgpermentidad: string;
  ndenunciadoIdcargo: number = null;
  ndenunciadoIdtipdoc: number;
  cargo: Cargo ;

  constructor() {
    this.cargo = new Cargo();
    this.tipoDocumento = new TipoDocumento();
    this.persona = new Persona();
  }

//   get dscFlgpermentidad(): string {
//     // return (this.cfurNroexpediente == null? "": this.cfurNroexpediente.substring(this.cfurNroexpediente.lastIndexOf("-") + 1));
//     return (this.cdenunciadoFlgpermentidad == "DE" ? DscFuncInvPEDe: this.cdenunciadoFlgpermentidad);
// }

  numIndex: number;
  // fichaXdenunciado: FichaXdenunciado = new FichaXdenunciado(); // uno a uno
}
